export default __webpack_public_path__ + "static/media/box-1.caf8af50.png";